import React from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';

const STOP = 2;

const FontSize = ({ max, min, value, onChange }) => {
  const handleClick = (direction) => {
    if (direction === 'up') {
      onChange(Number(value + STOP));
    } else {
      onChange(Number(value - STOP));
    }
  };

  const handleChange = (e) => {
    const inputValue = Number(e.target.value);
    let updateValue = null;
    if (inputValue < min) {
      updateValue = min;
    } else if (value > max) {
      updateValue = max;
    }
    onChange(updateValue || inputValue);
  };

  return (
    <div className="font-size-container">
      <button className="font-size-button" onClick={(e) => handleClick('down')} disabled={value <= min}>
      <FaMinus />
      </button>
      <input className="font-size-input"
        type="number"
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
      ></input>
      <button className="font-size-button" onClick={(e) => handleClick('up')} disabled={value >= max}>
        <FaPlus />
      </button>
    </div>
  );
};

export default FontSize;
